module.exports = __webpack_public_path__ + "static/mb-351b2fa9187a85f51f65af72b9e93c49.mp4";